import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { TranslationsApi } from '../api/TranslationsApi';
import { translationLangaugeResource } from '../components/common/CommonTypes';

const abortController = new AbortController();

const fetchTranslationsSuccess = (resources: translationLangaugeResource[]) => {
  resources.forEach((lng) => {
    i18next.addResourceBundle(
      lng.Language,
      'translation',
      lng.Resources,
      false,
      true
    );
  });
};

const fetchTranslationsFailure = (error: string) => {
  console.log(error);
};

i18next.use(initReactI18next).use(LanguageDetector).init({
  debug: true,
  fallbackLng: 'en'
});

new TranslationsApi().getTranslations(
  fetchTranslationsSuccess,
  fetchTranslationsFailure,
  abortController.signal
);
